import styled from 'styled-components';
import { computeSize } from '../../utils/object-utilities';

export const Container = styled.div.attrs({ className: 'dsc-skeleton' })`
  display: ${({ $width, $height }) => ($width || $height ? 'inline-block' : 'block')};
  width: ${({ $width }) => computeSize($width, undefined, '100%')};
  height: ${({ $height }) => computeSize($height, undefined, '100%')};
`;
